import React, { useMemo } from 'react';
import FocusTrap from 'focus-trap-react';
import BoostPanel from 'components/Boost/Boost';
import useFeatureFlagsQuery from 'common/Hooks/UseFeatureFlagsQuery';
import type { VenueWithMenus } from 'components/SingleItem/Details';

interface Props {
  currentVenue?: VenueWithMenus;
  menuSurchargePublishCount: number;
}

const BOOST_FEATURE_FLAG = 'boostEnabled';

const Boost: React.FC<Props> = ({ currentVenue, menuSurchargePublishCount }) => {
  const [featureFlagsData, featureFlagsLoading, featureFlagsError] = useFeatureFlagsQuery([BOOST_FEATURE_FLAG]);
  const isBoostEnabled = useMemo(() => {
    if (featureFlagsLoading || featureFlagsError || !featureFlagsData) {
      return false;
    }

    const boostFeatureFlag = featureFlagsData[BOOST_FEATURE_FLAG];
    return boostFeatureFlag ? boostFeatureFlag.isEnabled : false;
  }, [featureFlagsData, featureFlagsLoading, featureFlagsError]);

  return (
    <div>
      {isBoostEnabled && currentVenue && (
        <FocusTrap
          active
          focusTrapOptions={{
            escapeDeactivates: false,
            clickOutsideDeactivates: true
          }}
        >
          <BoostPanel
            currentVenue={currentVenue}
            isBoostEnabled={isBoostEnabled}
            menuSurchargePublishCount={menuSurchargePublishCount}
          />
        </FocusTrap>
      )}
    </div>
  );
};

export default Boost;
